let previouslyAppliedTokenKeys = [];

export function applyTokens(tokens) {
  const root = document.documentElement;

  for (const oldKey of previouslyAppliedTokenKeys) {
    if (!(oldKey in tokens)) {
      root.style.removeProperty(oldKey);
    }
  }

  for (const [key, value] of Object.entries(tokens)) {
    root.style.setProperty(key, value);
  }

  previouslyAppliedTokenKeys = Object.keys(tokens);
}
